import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";

const links = [
  { href: "#ubicacion", label: "Ubicación" },
  { href: "#galeria", label: "Galería" },
  { href: "#detalles", label: "Detalles" },
  { href: "#hospedaje", label: "Hospedaje" },
  { href: "#rsvp", label: "Confirmar" },
];

export default function Header() {
  const wedding = useContent();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,color] duration-500 ${
        scrolled ? "bg-paper/85 backdrop-blur-md border-b border-black/10 text-ink" : "bg-transparent text-white"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" className="font-display text-lg sm:text-xl tracking-tight" data-testid="header-monogram">
          {wedding.monogram}
        </a>
        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="overline hover:opacity-50 transition-opacity duration-300"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a href="#rsvp" className="overline md:hidden" data-testid="nav-mobile-rsvp">
          Confirmar
        </a>
      </div>
    </motion.header>
  );
}
